import { api } from '@/lib/api';

export type LyrraAccessPadGuideAudioResponse = {
  audioUrl: string;
  lang: string;
  cached: boolean;
  voiceId: string;
};

export async function fetchLyrraAccessPadGuideAudio(lang: string): Promise<LyrraAccessPadGuideAudioResponse> {
  const res = await api.get<{
    success: boolean;
    data: LyrraAccessPadGuideAudioResponse;
  }>('/public/lyrra-access-pad/guide-audio', { lang });
  return res.data;
}
